import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Spin,
  Select,
  message,
  Tooltip,
  Button,
  Cascader,
  Input,
  Tag,
  Radio,
} from "antd";
import { useMemo, useState } from "react";
import MotionHoc from "../../../utils/MotionHoc";
import {
  SearchOutlined,
  FilterOutlined,
  ReloadOutlined,
  DownSquareOutlined,
  UpSquareOutlined,
  FilePdfOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import {
  BASE_URL_BEN,
  HEADERS_EXPORT_BEN,
  POST_LOAD_BY_DATE,
  POST_LOAD_BY_QUERY,
  POST_LOAN_DB2,
} from "../../API/apiUrls";
import { optionsLocat } from "../../../utils/constant/LocatOption";
import { cancelCodeOptions } from "./constant/CancelCodeOption";
import { getSchemaContractOptions } from "./constant/SchemaOption";
import ThaiDatePicker, {
  ThaiMonthPicker,
  ThaiRangePicker,
} from "../../../hook/ThaiDatePicker";
import UpdateReplyEms from "./modal/UpdateReplyEms";
import { excelForPostOffice } from "./export/ExportPostOffice";
import { createPdfRePrintAcc2And8 } from "./export/ExportRePrintAcc2And8ResponePage";
import { createPdfRePrintAcc1 } from "./export/ExportRePrintAcc1ResponePage";
import { createPdfRePrintAcc3 } from "./export/ExportRePrintAcc3ResponePage";

const Main = () => {
  const userCompany = localStorage.getItem("COMPANY_ID");
  const contractOptions = getSchemaContractOptions(userCompany);
  const [loading, setLoading] = useState(false);
  const [arrData, setArrData] = useState([]);
  const [arrayTable, setArrayTable] = useState([]);
  const [forPaySelect, setForPaySelect] = useState(null);
  const [selectedGCode, setSelectedGCode] = useState(null);
  const [datePickerTable, setDatePickerTable] = useState(null);
  const [selectedContractTable, setSelectedContractTable] = useState(null);
  const [searchInputTable, setSearchInputTable] = useState(null);
  const [rawData, setRawData] = useState();
  const [cancelCodeSelect, setCancelCodeSelect] = useState([]);
  const [arrow, setArrow] = useState("Show");
  const [datePickerLoad, setDatePickerLoad] = useState(null);
  const [advanceSearch, setAdvanceSearch] = useState(false);
  const [searchInput, setSearchInput] = useState(null);
  const [searchSelect, setSearchSelect] = useState(2);
  const [selectStatusTable, setSelectStatusTable] = useState(null);
  const [isModalUpdateEms, setIsModalUpdateEms] = useState(false);
  const [postOfficeTypeSelect, setPostOfficeTypeSelect] = useState(1);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const toggle = () => setAdvanceSearch((v) => !v);
  const { Option } = Select;
  const [searchSelectType, setSearchSelectType] = useState(1);

  const renderOpteionSearch = () => {
    return (
      <>
        <Option value={1}>
          <span style={{ marginRight: 8 }}>📑</span>
          เลขสัญญา
        </Option>
        <Option value={2}>
          <span style={{ marginRight: 8 }}>📨</span>
          เลขไปรษณีย์
        </Option>
        <Option value={3}>
          <span style={{ marginRight: 8 }}>👤</span>ชื่อ-กสุล
        </Option>
        <Option value={0}>
          <span style={{ marginRight: 8 }}>🗓️</span>รอบเดือน
        </Option>
      </>
    );
  };

  const renderOpteionSearchType = () => {
    return (
      <>
        <Option value={0}>
          <span style={{ marginRight: 8 }}>📑</span>
          ปกติ
        </Option>
        <Option value={1}>
          <span style={{ marginRight: 8 }}>📨</span>
          บอกเลิกมือ
        </Option>
        <Option value={2}>
          <span style={{ marginRight: 8 }}>👤</span>ใช้สิทธ์ซื้อรถคืน
        </Option>
      </>
    );
  };

  const renderOpteionStatus = () => {
    return (
      <>
        <Option value={4}>
          <span style={{ marginRight: 8 }}>🗂️</span>
          ทั้งหมด
        </Option>
        <Option value={1}>
          <span style={{ marginRight: 8 }}>📩</span>
          ใบตอบกลับ
        </Option>
        <Option value={2}>
          <span style={{ marginRight: 8 }}>🌐</span>เว็บไปรษณีย์
        </Option>
        <Option value={3}>
          <span style={{ marginRight: 8 }}>✉️🔙</span>ตีกลับ
        </Option>
        <Option value={0}>⏳ รอดำเนินการ</Option>
      </>
    );
  };

  const contractLabelByValue = useMemo(() => {
    return Object.fromEntries(
      (contractOptions ?? []).map((o) => [o.value, o.label]),
    );
  }, [contractOptions]);

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const onCascaderChange = (value, selectedOptions) => {
    console.log("value", value);
    setCancelCodeSelect(value);
    const [forPay, gcode] = value || [];
    setForPaySelect(forPay);
    setSelectedGCode(gcode);
  };

  const handleLoad = () => {
    console.log("searchSelect", searchSelect);
    console.log("searchInput", searchInput);
    console.log("datePickerLoad", dayjs(datePickerLoad).format("YYYY-MM-DD"));
    if (searchSelect !== null && (searchInput || datePickerLoad)) {
      setForPaySelect(null);
      setSelectedGCode(null);
      setCancelCodeSelect([]);
      setRawData([]);
      setArrayTable([]);
      setSelectedContractTable(null);
      setSelectStatusTable(null);
      setSelectedGCode(null);
      setForPaySelect(null);
      setDatePickerTable(null);
      setSearchInputTable(null);
      setCancelCodeSelect([]);
      setSelectedRows([]);
      setSelectedRowKeys([]);

      handlePreLoad(searchInput);
    } else {
      if (searchSelect === 0 && !datePickerLoad) {
        message.error("กรุณาเลือก ว/ด/ป  !! ");
      } else {
        message.error("กรุณาเลือกกรอกข้อมูลในช่องค้นหา !! ");
      }
    }
  };

  const loadData = async (payload, apiUse) => {
    setLoading(true);
    try {
      const { data, status } = await axios.post(
        BASE_URL_BEN + apiUse,
        payload,
        { headers: HEADERS_EXPORT_BEN },
      );

      if (status !== 200 || data.message === "ไม่พบข้อมูล") {
        setArrayTable([]);
        setArrData([]);
        message.warning("ไม่มีข้อมูล");
        return;
      }

      console.log("res data", data);
      filterData(data);
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg = error?.response?.data?.message;
      console.error("API error:", status, serverMsg || error.message);

      setArrayTable([]);
      setArrData([]);
      message.error(serverMsg || `ไม่สามารถดึงข้อมูลได้ (${status ?? " - "})`);
    } finally {
      setLoading(false);
    }
  };

  const filterData = (value) => {
    if (Array.isArray(value)) {
      let filteredDataCompany;
      console.log(userCompany);

      if (userCompany === "3") {
        console.log("1");
        filteredDataCompany = value.filter((item) => {
          const branch = item.LOCAT;
          if (!branch) return true;
          return (
            !optionsLocat.some((opt) => branch.includes(opt.label)) ||
            item.contractNo.includes("UD")
          );
        });
      } else {
        console.log("2");
        filteredDataCompany = value.filter((item) => {
          const branch = item.LOCAT;
          if (!branch) return false;
          return optionsLocat.some((opt) => branch.includes(opt.label));
        });
      }

      let i = 1;

      const newData = filteredDataCompany.map((item) => ({
        ...item,
        key: i++,
      }));

      setRawData(newData);
      console.log("dataContractUse", newData);
      newData.length > 0 ? setAdvanceSearch(true) : setAdvanceSearch(false);
      setArrData(newData);
      setArrayTable(newData);
      if (searchSelect === 2 && newData[0].status === 0) {
        setRawData(newData[0]);
        setIsModalUpdateEms(true);
      }
      setLoading(false);
    }
  };

  const handleSearchSelect = (value) => {
    setSearchSelect(value); // value จะเป็น 1/2/3/4 (เพราะไม่ได้ใช้ labelInValue)
    setSearchInput(null); // ล้างช่องพิมพ์
    !value ? setDatePickerLoad(dayjs()) : setDatePickerLoad(null); // ล้างวันที่
  };

  const handleSearchSelectType = (value) => {
    setSearchSelectType(value); // value จะเป็น 1/2/3/4 (เพราะไม่ได้ใช้ labelInValue)
  };

  const renderProcess = (record) => {
    let value =
      record.status === 1
        ? "ใบตอบกลับ"
        : record.status === 2
          ? "ไปรษณีย์"
          : record.status === 3
            ? "ตีกลับ"
            : "รอดำเนินการ";
    let color =
      record.status === 1 || record.status === 2 || record.status === 3
        ? "green"
        : "blue";

    return (
      <Tag color={color} key={value} style={{ textAlign: "center" }}>
        {value}
        <br />
        {record.dateResponse
          ? dayjs(record.dateResponse).add(543, "year").format("D MMM YY")
          : null}
      </Tag>
    );
  };

  const handlefilterData = () => {
    setLoading(true);
    setSelectedRows([]);
    setSelectedRowKeys([]);
    const rows = Array.isArray(arrData) ? arrData : [];

    const norm = (v) => String(v ?? "").trim();
    const sameDay = (a, b) =>
      !!a &&
      !!b &&
      dayjs(a).format("YYYY-MM-DD") === dayjs(b).format("YYYY-MM-DD");

    const inRange = (dt, [from, to]) => {
      if (!dt || !from || !to) return false;
      const ts = dayjs(dt).valueOf();
      const s = dayjs(from).startOf("day").valueOf();
      const e = dayjs(to).endOf("day").valueOf();
      return ts >= s && ts <= e;
    };

    // ---- ค่าจาก UI ----
    const q = norm(searchInputTable); // ข้อความค้นหา
    const schemaVal =
      selectedContractTable?.value ?? selectedContractTable ?? "";
    const forVal = String(forPaySelect ?? "");
    const gVal = String(selectedGCode ?? "");
    const dateSel = datePickerTable;

    // รองรับทั้งค่าตรง ๆ หรือ labelInValue ({value, label})
    const statusVal =
      selectStatusTable && typeof selectStatusTable === "object"
        ? selectStatusTable.value
        : selectStatusTable; // คาดว่าเป็น 0|1|2|3|4|undefined|null

    const result = rows.filter((item) => {
      // 1) Search: contractNo / customerFullname / parcelNo / parcelNoResponse
      const passQuery =
        !q ||
        [
          item.contractNo,
          item.customerFullname,
          item.parcelNo,
          item.parcelNoResponse,
        ]
          .map(norm)
          .some((val) => val.includes(q));

      // 2) สัญญา (contract_schema)
      const passSchema =
        !schemaVal || String(item.contract_schema) === String(schemaVal);

      // 3) FOR (payType) — ถ้าเลือก 116 ให้รวม 115 ด้วย (ตาม logic เดิม)
      const passFor =
        !forVal ||
        String(item.payType) === forVal ||
        (forVal === "116" && String(item.payType) === "115");

      // 4) GCODE (accountType)
      const passG = !gVal || String(item.accountType) === gVal;

      // 5) วันที่ (datetime) รองรับทั้งวันเดียวและช่วงวันที่
      let passDate = true;
      if (dateSel) {
        passDate =
          Array.isArray(dateSel) && dateSel.length === 2
            ? inRange(item.datetime, dateSel)
            : sameDay(item.datetime, dateSel);
      }

      let passStatus = true;
      if (statusVal === 4) {
        passStatus = true;
      } else if (statusVal == null) {
        // ถ้าสตรีมมาเป็น null (เช่น clear) ก็ไม่กรอง
        passStatus = true;
      } else {
        passStatus = String(item.status) === String(statusVal);
      }

      return (
        passQuery && passSchema && passFor && passG && passDate && passStatus
      );
    });

    setArrayTable(result);
    setTimeout(() => {
      setLoading(false);
    }, 250);
    if (result.length === 0) message.error("ไม่พบข้อมูล");
  };

  const onChangeInputSearchLoad = (data) => {
    console.log(data.length);
    setSearchInput(data);
    if (data.length === 13 && searchSelect === 2) {
      handlePreLoad(data);
    }
  };

  const handleUpdateData = (data) => {
    console.log(data);

    if (data.status > 0 && searchSelect === 2) {
      handlePreLoad(data.parcelNoResponse);
    } else if (data.status > 0 && searchSelect === 1) {
      handlePreLoad(data.contractNo);
    } else if (data.status > 0 && searchSelect === 3) {
      handlePreLoad(data.customerFullname);
    } else if (data.status > 0 && searchSelect === 0) {
      handlePreLoad();
    }
    console.log(searchSelect, data);
  };

  const handlePreLoad = (data) => {
    let preDataLoad = {};
    let apiUse;
    console.log(data, datePickerLoad);
    if (searchSelect !== 0) {
      preDataLoad = {
        selectType: searchSelect,
        text: data.trim(),
      };
      apiUse = POST_LOAD_BY_QUERY;
    } else {
      preDataLoad = {
        selectType: searchSelectType,
        date: dayjs(datePickerLoad).format("YYYY-MM-DD"),
      };
      apiUse = POST_LOAD_BY_DATE;
    }
    loadData(preDataLoad, apiUse);
  };

  const handleChangeRadio = (value) => {
    console.log("value", value);
    setPostOfficeTypeSelect(value);
  };

  const handleClickDonwLoadExcel = async () => {
    setLoading(true);
    try {
      await excelForPostOffice(selectedRows, postOfficeTypeSelect);
      message.success("โหลด Excel สำเร็จ");
    } catch (e) {
      console.error(e);
      message.error(`พิมพ์ไม่สำเร็จ: ${e?.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }
  };

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedRows(selectedRows);
    console.log("Selected Row Keys:", selectedRowKeys); // คีย์ของแถวที่เลือก
    console.log("Selected Rows Data:", selectedRows); // ข้อมูลของแถวที่เลือก
  };

  // ป้องกัน contractNo ซ้ำ
  const getUniqueContractNos = (rows = []) => {
    const set = new Set((rows || []).map((r) => r?.contractNo).filter(Boolean));
    return Array.from(set);
  };

  function mergeIntoEachSelectedRow(apiData = [], selectedRows = []) {
    const normKey = (v) =>
      String(v ?? "")
        .trim()
        .toUpperCase();
    const asStr = (v) => String(v ?? "").trim();
    const eq = (a, b) => asStr(a) === asStr(b);

    // เลือก address จากลิสต์ตาม ADDRMAIL; ถ้าไม่เจอให้ fallback เป็นตัวแรก
    const pickAddressByAddrMail = (addressList = [], addrMail) => {
      if (!Array.isArray(addressList) || addressList.length === 0) return null;
      const want = asStr(addrMail || addressList[0]?.ADDRNO);
      const found = addressList.find((a) => eq(a?.ADDRNO, want));
      return found || addressList[0] || null;
    };

    // เลือก party ตาม customerTypeID (0 = CUSTOMER, >0 = GUARANTOR ตาม GARNO)
    const getPartyByType = (apiObj = {}, customerTypeID = 0) => {
      if (!apiObj) return null;
      const ctype = Number(customerTypeID) || 0;
      if (ctype === 0) return apiObj.CUSTOMER || null;
      const garList = Array.isArray(apiObj.GUARANTORS) ? apiObj.GUARANTORS : [];
      return garList.find((g) => Number(g?.GARNO) === ctype) || null;
    };

    const apiArr = Array.isArray(apiData) ? apiData : apiData ? [apiData] : [];

    // ทำ map: CONTNO -> apiObject
    const apiMap = new Map();
    apiArr.forEach((obj) => {
      const contno =
        obj?.LOAN?.CONTNO || obj?.MORTGAGE?.CONTNO || obj?.CUSTOMER?.CONTNO;
      const k = normKey(contno);
      if (!k) return;
      if (!apiMap.has(k)) apiMap.set(k, obj);
    });

    // วิ่งตาม selectedRows แล้วอัดข้อมูล + คำนวณที่อยู่ลงในแต่ละแถว
    return (selectedRows || []).map((row) => {
      const k = normKey(row?.contractNo);
      const api = apiMap.get(k) || null;

      // ค่าประเภทลูกค้า (ลองรองรับหลายชื่อ field)
      const customerTypeID =
        row?.customerTypeID ?? row?.cusType ?? row?.customer_type_id ?? 0;

      const party = api ? getPartyByType(api, customerTypeID) : null;
      const addrObj = party
        ? pickAddressByAddrMail(party.ADDRESS || [], party.ADDRMAIL)
        : null;

      // ชื่อ-นามสกุลสำหรับพิมพ์ (ถ้าต้องใช้)
      const partyName = party
        ? [party.SNAM, party.NAME1, party.NAME2]
            .filter(Boolean)
            .join(" ")
            .trim()
        : "";

      return {
        ...row, // คงข้อมูลเดิม
        apiRaw: api,
        addressObj: addrObj,
      };
    });
  }

  // schema ต้องเหมือนทั้งก้อน
  const getUniformSchema = (rows = []) => {
    if (!Array.isArray(rows) || rows.length === 0) return null;
    const first = rows[0]?.contract_schema ?? null;
    if (first == null) return null;
    return rows.every((r) => r?.contract_schema === first) ? first : null;
  };

  // ---- ทำงาน “หลังจาก return api” ที่นี่ ----
  const handleReprint = async () => {
    if (!Array.isArray(selectedRows) || selectedRows.length === 0) {
      message.warning("โปรดเลือกข้อมูลอย่างน้อย 1 แถว");
      return;
    }

    const schema = getUniformSchema(selectedRows);
    if (!schema) {
      message.error("โปรดเลือกสัญญาเหมือนกันทั้งหมด");
      return;
    }

    const nos = getUniqueContractNos(selectedRows);
    if (nos.length === 0) {
      message.error("ไม่พบเลขที่สัญญา");
      return;
    }

    // สร้างพารามิเตอร์ให้ backend (เช่น 'A','B','C')
    const contnoParam = nos
      .map((v) => `'${String(v).replace(/'/g, "''")}'`)
      .join(",");

    setLoading(true);
    try {
      // 1) รอ API ให้เสร็จก่อน
      const apiData = await loadDataReprint({ CONTNO: contnoParam });
      if (!apiData || (Array.isArray(apiData) && apiData.length === 0)) {
        message.error("ไม่พบข้อมูลสำหรับพิมพ์");
        return;
      }

      // 2) รวมข้อมูล API + แถวที่เลือก (ทำ “หลังจาก return api”)
      const merged = mergeIntoEachSelectedRow(apiData, selectedRows);
      console.log("merged", merged);

      // 3) เรียก PDF ตาม schema
      if (schema === "lsfhp") {
        await createPdfRePrintAcc1(merged);
      } else if (schema === "vsfhp" || schema === "sfhp") {
        await createPdfRePrintAcc2And8(merged);
      } else if (schema === "rpsl") {
        await createPdfRePrintAcc3(merged);
      } else {
        message.error(`ยังไม่รองรับสัญญาแบบ: ${schema}`);
      }
    } catch (e) {
      console.error(e);
      message.error(`พิมพ์ไม่สำเร็จ: ${e?.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }
  };

  const loadDataReprint = async (payload) => {
    try {
      const res = await axios.post(POST_LOAN_DB2, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (res.status === 200) {
        if (!res.data) {
          message.error("สัญญาไม่ถูกต้อง โปรดตรวจสอบสัญญา");
          return null;
        }
        if (typeof res.data === "string") {
          // กรณีข้อความ error ที่มาเป็น string
          if (res.data.includes("Contract No. Not Found")) {
            message.error("ไม่พบเลขที่สัญญา");
            return null;
          }
          message.error(res.data);
          return null;
        }
        return Array.isArray(res.data) ? res.data : [res.data];
      }

      message.error("ดึงข้อมูลไม่สำเร็จ");
      return null;
    } catch (err) {
      console.error("loadDataReprint error:", err);
      message.error("เกิดข้อผิดพลาดในการดึงข้อมูล");
      return null;
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (rowKeys, selectedRows) => {
      onSelectChange(rowKeys, selectedRows);
    },
  };

  const columns = [
    {
      title: "ลำดับ",
      align: "center",
      dataIndex: "no", // ใช้ dataIndex เพื่อรองรับการ sort
      render: (text, record, index) => <>{record.key}</>, // แสดงค่า no + 1
    },

    {
      title: "เลขที่สัญญา",
      dataIndex: "contractNo",
      key: "contractNo",
      align: "center",
      render: (text, record) => (
        <>
          {record.contractNo ? record.contractNo : null} <br />
          {contractLabelByValue?.[record?.contract_schema]}
        </>
      ),
    },

    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "customerFullname",
      key: "customerFullname",
      align: "center",
      render: (text, record) => (
        <>{record.customerFullname ? record.customerFullname : null} </>
      ),
    },
    {
      title: "ประเภทลูกค้า",
      align: "center",
      render: (text, record) => (
        <>
          {record.customerTypeID === 0
            ? "ผู้เช่าซื้อ"
            : `ผู้ค้ำที่ ${record.customerTypeID}`}
        </>
      ),
    },

    {
      title: "รอบข้อมูล",
      align: "center",
      render: (text, record) => (
        <>
          {record.docNo
            ? dayjs(record.datetime).add(543, "year").format("D MMM YY")
            : null}
        </>
      ),
    },
    {
      title: "ems จดหมาย",
      dataIndex: "parcelNo",
      key: "parcelNo", // ใช้ key แทน dataIndex เพราะเราไม่ต้องการใช้ข้อมูลจาก data
      align: "center",
    },
    {
      title: "ems ใบตอบกลับ",
      dataIndex: "parcelNoResponse",
      key: "parcelNoResponse", // ใช้ key แทน dataIndex เพราะเราไม่ต้องการใช้ข้อมูลจาก data
      align: "center",
    },
    {
      title: "สถานะ",
      align: "center",
      render: (text, record) => <>{renderProcess(record)}</>,
    },
    {
      title: "การจัดการ",
      align: "center",
      render: (text, record) => (
        <>
          <Button
            color="cyan"
            variant="outlined"
            onClick={() => {
              setRawData(record);
              setIsModalUpdateEms(true);
            }}
          >
            อัพเดท
          </Button>
        </>
      ),
    },
  ];

  return (
    <>
      <Card>
        <Row>
          <Col span={"24"} style={{ textAlign: "start" }}>
            <Space direction="horizontal" size={8}>
              <Tooltip
                title={advanceSearch ? "ซ่อนตัวกรอง" : "แสดงตัวกรอง"}
                arrow={mergedArrow}
              >
                {!advanceSearch ? (
                  <DownSquareOutlined
                    style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                    onClick={toggle} // antd ส่งค่า checked มาให้
                  />
                ) : (
                  <UpSquareOutlined
                    style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                    onClick={toggle} // antd ส่งค่า checked มาให้
                  />
                )}
              </Tooltip>

              <Select
                size="large"
                style={{ minWidth: "auto", marginRight: 8 }}
                placeholder="เลือกการค้นหา"
                popupMatchSelectWidth={false}
                value={searchSelect}
                onChange={handleSearchSelect}
                showSearch
                optionFilterProp="label"
              >
                {renderOpteionSearch()}
              </Select>
              {!searchSelect && (
                <Select
                  size="large"
                  style={{ minWidth: "auto", marginRight: 8 }}
                  placeholder="เลือกการค้นหา"
                  popupMatchSelectWidth={false}
                  value={searchSelectType}
                  onChange={handleSearchSelectType}
                  showSearch
                  optionFilterProp="label"
                >
                  {renderOpteionSearchType()}
                </Select>
              )}
              {searchSelect !== 0 ? (
                <Input
                  placeholder="ค้นหาสัญญา"
                  value={searchInput}
                  onChange={(e) => onChangeInputSearchLoad(e.target.value)} // เก็บค่าที่พิมพ์
                  style={{
                    width: "auto",
                    borderRadius: "8px",
                  }}
                  size="small"
                  suffix={
                    searchSelect === 1 ? (
                      <span style={{ marginRight: 5 }}>📑</span>
                    ) : searchSelect === 2 ? (
                      <span style={{ marginRight: 5 }}>📨</span>
                    ) : searchSelect === 3 ? (
                      <span style={{ marginRight: 5 }}>👤</span>
                    ) : null
                  }
                />
              ) : (
                <ThaiMonthPicker
                  value={datePickerLoad}
                  onChange={setDatePickerLoad}
                  size="large"
                />
              )}
              <Button
                type="primary"
                icon={<SearchOutlined />}
                size="large"
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  fontWeight: "bold",
                  background: "linear-gradient(135deg, #667eea, blue)",
                  border: "none",
                  marginLeft: 5,
                }}
                onClick={handleLoad}
                disabled={loading}
              >
                ค้นหา
              </Button>
              <Button
                icon={<ReloadOutlined />}
                onClick={() => {
                  setSearchInput(null);
                  setDatePickerLoad(null);
                }}
                color="red"
                variant="outlined"
              >
                ล้าง
              </Button>
            </Space>
          </Col>
          <Col
            span={"12"}
            style={{
              textAlign: "start",
              marginTop: "10px",
            }}
          >
            <Button
              type="text"
              icon={
                <FilePdfOutlined
                  style={{
                    fontSize: "24px",
                  }}
                />
              }
              onClick={() => handleReprint()}
              disabled={selectedRows.length === 0 || loading}
              color={selectedRows.length === 0 ? "grey" : "red"}
              variant="outlined"
            >
              Re-Print
            </Button>
          </Col>
          <Col span={"12"} style={{ textAlign: "end" }}>
            <Radio.Group
              style={{ marginRight: "10px" }}
              name="postOfficeType"
              defaultValue={postOfficeTypeSelect}
              options={[
                { value: 1, label: "ลงทะเบียน" },
                { value: 2, label: "EMS" },
              ]}
              onChange={(e) => {
                handleChangeRadio(e.target.value);
              }}
            />
            <Button
              type="text"
              icon={
                <PrinterOutlined
                  style={{
                    fontSize: "24px",
                    color: selectedRows.length === 0 ? "grey" : "green",
                  }}
                />
              }
              onClick={handleClickDonwLoadExcel}
              disabled={selectedRows.length === 0 || loading}
              style={{
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                borderRadius: "8px",
                padding: "10px",
              }}
            >
              Excel
            </Button>
          </Col>
        </Row>
      </Card>
      <Card>
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Row>
            {advanceSearch ? (
              <Col span={24} style={{ textAlign: "start" }}>
                <Space direction="horizontal" size={8}>
                  <Select
                    key={userCompany}
                    size="large"
                    style={{ minWidth: "auto", marginRight: 8 }}
                    placeholder="เลือกสัญญา"
                    popupMatchSelectWidth={false}
                    labelInValue // ★ เปิดใช้
                    value={selectedContractTable} // ต้องเป็น object { value, label }
                    onChange={(obj) => setSelectedContractTable(obj ?? null)} // obj = { value, label }
                    options={contractOptions}
                    allowClear
                    showSearch
                    optionFilterProp="label"
                  />
                  <Cascader
                    value={cancelCodeSelect}
                    options={cancelCodeOptions}
                    onChange={onCascaderChange}
                    placeholder="เลือกประเภทข้อมูล"
                    allowClear
                    showSearch
                    size="large"
                    style={{
                      width: "auto",
                      marginRight: 8,
                    }}
                  />
                  <ThaiRangePicker
                    value={datePickerTable}
                    onChange={setDatePickerTable}
                    size="large"
                  />
                  <Select
                    size="large"
                    style={{ minWidth: "auto", marginLeft: 8 }}
                    placeholder="เลือกสถานะ"
                    popupMatchSelectWidth={false}
                    value={selectStatusTable}
                    onChange={setSelectStatusTable}
                    allowClear
                    showSearch
                    optionFilterProp="label"
                  >
                    {renderOpteionStatus()}
                  </Select>
                  <Input
                    placeholder="ค้นหาสัญญาในตาราง"
                    value={searchInputTable}
                    onChange={(e) => setSearchInputTable(e.target.value)} // เก็บค่าที่พิมพ์
                    style={{
                      width: "auto",
                      borderRadius: "8px",
                    }}
                    size="small"
                    suffix={<span style={{ marginRight: 5 }}>🔍</span>}
                  />
                  <Button
                    type="default"
                    icon={<FilterOutlined />}
                    size="large"
                    style={{
                      borderRadius: "8px",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      fontWeight: "bold",
                      backgroundColor: "#fff7d6",
                      color: "#333",
                      border: "1px solid #ffe58f",
                      marginLeft: 8,
                    }}
                    onClick={handlefilterData}
                    disabled={loading}
                  >
                    กรองข้อมูล
                  </Button>
                  <Button
                    icon={<ReloadOutlined />}
                    onClick={() => {
                      setSelectedContractTable(null);
                      setSelectStatusTable(null);
                      setSelectedGCode(null);
                      setForPaySelect(null);
                      setDatePickerTable(null);
                      setSearchInputTable(null);
                      setCancelCodeSelect([]);
                      setSelectedRows([]);
                      setSelectedRowKeys([]);
                    }}
                    color="red"
                    variant="outlined"
                  >
                    ล้าง
                  </Button>
                </Space>
              </Col>
            ) : null}
            <Col span={"24"}>
              <Table
                style={{ marginTop: "10px" }}
                size="small"
                columns={columns}
                dataSource={arrayTable}
                scroll={{ x: 850 }}
                rowSelection={rowSelection}
                rowKey={(row) => row.key || row.id || row.DOCNO}
                footer={() => (
                  <p>จำนวนสัญญาที่ค้นหาทั้งหมด {arrayTable.length} </p>
                )}
              />
            </Col>
          </Row>
        </Spin>
      </Card>
      {isModalUpdateEms ? (
        <UpdateReplyEms
          open={isModalUpdateEms}
          close={setIsModalUpdateEms}
          dataDefault={rawData}
          funcUpdateStatus={handleUpdateData}
        />
      ) : null}
    </>
  );
};

const UpdateStatusResponse = MotionHoc(Main);
export default UpdateStatusResponse;
